package com.yogaaicoach.pages.auth

import com.yogaaicoach.pages.auth.ForgotPasswordViewModel
import com.yogaaicoach.scope
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import react.useEffectOnce
import react.useState
import web.cssom.ClassName
import web.html.InputType
import web.html.email

internal external interface ForgotPasswordPageProps : Props {
    var viewModel: ForgotPasswordViewModel
    var onNavigateToConfirmation: (String) -> Unit
}

// Pixel-matched against ForgotPasswordScreen.kt (AuthPageLayout + FormSectionCard).
internal val ForgotPasswordPage = FC<ForgotPasswordPageProps> { props ->
    val viewModel = props.viewModel

    var email by useState(viewModel.email.value)
    var error by useState(viewModel.error.value)
    var isLoading by useState(viewModel.isLoading.value)

    useEffectOnce {
        scope.launch { viewModel.email.collect { email = it } }
        scope.launch { viewModel.error.collect { error = it } }
        scope.launch { viewModel.isLoading.collect { isLoading = it } }
    }

    div {
        className = ClassName("auth-page")

        img { className = ClassName("auth-logo"); src = "logo.png"; alt = "App logo" }
        p { className = ClassName("auth-brand"); +"Yoga AI Coach" }

        div {
            className = ClassName("form-section-card")

            p { className = ClassName("form-title"); +"Reset Password" }
            p { className = ClassName("form-subtitle"); +"We'll send you a reset link" }

            p { className = ClassName("auth-error"); +error }

            FloatingLabelInput("forgot-email-input", "Email", InputType.email, email) { viewModel.onEmailChange(it) }

            button {
                className = ClassName(if (isLoading) "primary-button loading" else "primary-button")
                disabled = isLoading
                onClick = { viewModel.onResetPassword { email -> props.onNavigateToConfirmation(email) } }
                if (isLoading) {
                    span { className = ClassName("button-spinner") }
                } else {
                    +"Send Reset Link"
                }
            }
        }
    }
}
